import { TransferBaseModel } from '../transfer-base.model';

export interface TradingGroup extends TransferBaseModel {
    trading_group: string;
    platform: string;
    tenant: string;
    currency_lookup?: string;
    account_type?: TradingGroupAccountType;
    pricing_type?: TradingGroupPricingType;
    sync_status?: TradingGroupSyncStatus;
    crm_spread_group_id?: string;
}

export enum TradingGroupPricingType {
    STANDARD = 'STANDARD',
    RAW = 'RAW'
}

export enum TradingGroupAccountType {
    MAM_MASTER = 'MAM Master',
    MAM_SLAVE = 'MAM Slave',
    REBATE = 'Rebate',
    TEST = 'Test',
    STANDARD = 'Standard'
}

export enum TradingGroupSyncStatus {
    NEW = 'NEW',
    SYNCED = 'SYNCED'
}
